import { scaffoldList } from "common/scaffolding/reducers/scaffoldList";
import { TypeKeys as EditTypeKeys } from "./edit";
import { MembershipProgram } from "../types";

enum TypeKeys {
    LOADING = "MEMBERSHIPS/LIST_BEGIN",
    LOADED = "MEMBERSHIPS/LIST_SUCCESS",
    FAILED = "MEMBERSHIPS/LIST_FAILURE",
    RELOAD = "MEMBERSHIPS/LIST_RELOAD",
}
const list = scaffoldList<MembershipProgram, typeof TypeKeys, typeof EditTypeKeys>(TypeKeys, EditTypeKeys);
const { createAction, reducer } = list;

export type State = ReturnType<typeof list.reducer>;
export { createAction, reducer };
